module.exports = __webpack_public_path__ + "fasaw10.png?b3f372441af49b79fd4215bebefb5b74";